// Combines all Reducers (Rules that determie how the State should be alterd)

import {combineReducers} from 'redux';

//FETCH ALL REDUCERS TO INCLUDE
import tasks from './task-reducer.js';
import pages from './page-reducer.js';

//COMBINES ALL REDUCERS INTO ONE -> LOAD CONTENT INTO STORE
const rootReducer = combineReducers({
  tasks,
  pages
});

export default rootReducer;



// WEBPACK FOOTER //
// ./client/reducers/reducers.js